import http from 'helpers/APIHelper';
import { httpStatusEnum } from 'appconstants';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';

export const VERSION_ACTIONS = {
  GET_VERSIONS: '@protocol/version/getversions',
  GET_PIO_VERSIONS: '@protocol/version/getpioversions',
  SAVE_VERSIONS: '@protocol/version/saveversions',
  SET_LOCAL_VER_EDIT_MODE: '@protocol/version/setLocalVersEditMode'
};

export const getVersions = (token, loggerInfo, id, postBody = {
  sort: [{ field: 'versionDate', value: 'desc' }]
}) => dispatch => {
  dispatch({
    type: VERSION_ACTIONS.GET_VERSIONS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/versions`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    )
    .subscribe(
      resp => {
        dispatch({
          type: VERSION_ACTIONS.GET_VERSIONS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: VERSION_ACTIONS.GET_VERSIONS + suffixRejected,
          payload: error
        });
      }
    );
};

export const saveVersions = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http
  .putWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/version`,
    token,
    loggerInfo,
    JSON.stringify(postBody)
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getVersions(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );

export const setLocalVerEditMode = props => dispatch => {
  const action = {
    type: VERSION_ACTIONS.SET_LOCAL_VER_EDIT_MODE,
    payload: props
  };
  dispatch(action);
};

export const getPioVersions = (token, loggerInfo, id, postBody = {
  sort: [{ field: 'localDate', value: 'desc' }]
}) => dispatch => {
  dispatch({
    type: VERSION_ACTIONS.GET_PIO_VERSIONS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/pioversions`,
      token,
      loggerInfo,
      JSON.stringify(postBody)
    )
    .subscribe(
      resp => {
        dispatch({
          type: VERSION_ACTIONS.GET_PIO_VERSIONS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: VERSION_ACTIONS.GET_PIO_VERSIONS + suffixRejected,
          payload: error
        });
      }
    );
};


export const cancelVersions = (token, loggerInfo, id, verId) => (
  dispatch,
  getState
) => http
  .deleteWithToken(
    `protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/id/${id}/versions/${verId}`,
    token,
    loggerInfo
  ).pipe(
    map(resp => {
      if (resp.status === httpStatusEnum.SUCCESS) {
        dispatch(
          getVersions(
            token,
            loggerInfo,
            getState().prtDetails.prtInfo.protocolNumber
          )
        );
      }
      return resp;
    })
  );
